import React, { useState } from 'react';
import constClass from '../../Constants/Constants';
import UseConfirmModal from '../Common/UseConfirmModal';
import Loading from '../Loading/Loading';
// import sound from '../Sound/Notify';

const PointDetail = ({ setMode, appState, setPointRegist, setRegistClose }) => {
  const [lockData, setLockData] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  var pointFlag = false;

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleSubmitClick = async () => {
    setConfirmModalMessage('ポイント付与を確定してよろしいですか？');
    setIsConfirmModalOpen(true);
    setOnConfirm(() => async () => {
      // if (appState.pointCampaignList.filter(x => (!Object.values(constClass.PAYMENT_METHOD).includes(x.payment_method.toString()) || !appState.paymentMethod || x.payment_method.toString() === appState.paymentMethod.toString())).length > 0) {
      //   sound.play();
      // };
      if (pointFlag) {
        return;
      }
      pointFlag = true;
      setLockData(true);
      closeConfirmModal();
      // await new Promise(resolve => setTimeout(resolve, 3000));
      await setPointRegist();
      setLockData(false);
    });
  }

  const handleCloseClick = () => {
    setMode(constClass.POINT_SCREEN.MAIN);
  }

  return (
    <div>
      {lockData && <Loading />}
      <UseConfirmModal isOpen={isConfirmModalOpen} message={confirmModalMessage} onConfirm={onConfirm} onClose={closeConfirmModal} disabled={lockData}/>
      {appState.pointRegist &&
        <div className='text-center font-weight-bold pt-3 text-alert'>ポイント付与が完了しました</div>
      }
      <div className="row">
        <div className="col my-3 text-left bg-white">
          <div className="card-header p-2 border">
            <span><b>会員ID:</b></span>
            <span className="float-right pl-2">{appState.membership_id}</span>
          </div>
          <div className="card-header p-2 text-left border">
            <span><b>保有ポイント:</b></span>
            <span className="float-right pr-2"><b>{appState.available_point.toLocaleString()}</b> ポイント</span>
          </div>
          <div className="card-header p-2 text-left border">
            <span><b>会員ランク:</b></span>
            <span className="float-right pr-2"><b>{appState.customer_rank ? appState.customer_rank.rank_name : null}</b></span>
          </div>
          <div className="card-header p-2 text-left border">
            <span><b>ポイント還元{appState.point_rate > 0 ? "率" : "基準額"}:</b></span>
            <span className="float-right pr-2"><b>{appState.point_rate ? Number(appState.point_rate) : appState.point_base_amount ? Number(appState.point_base_amount) : null}</b> {appState.point_rate > 0 ? "％" : "円に1ポイント"}</span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col my-3 text-left bg-white">
          <div className="card-header p-2 border">
            <span><b>決済手段:</b></span>
            <span className='float-right pl-2'>{appState.paymentMethod in constClass.PAYMENT_METHOD_NAME ? constClass.PAYMENT_METHOD_NAME[appState.paymentMethod] : ""}</span>
          </div>
          <div className="card-header p-2 border">
            <span><b>対象金額:</b></span>
            <span className='float-right pl-2'>{appState.inputValue.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}</span>
          </div>
          <div className="card-header p-2 text-left border">
            <span><b>{appState.pointRegist ? "加算" : "付与予定"}ポイント:</b></span>
            <span className="float-right pr-2"><b>{appState.addPoint.toLocaleString()}</b> ポイント</span>
          </div>
          {(appState.pointRegist && appState.pointCampaignList.length > 0) &&
            appState.pointCampaignList.map((item, idx) =>
              <div className="card-header p-2 text-left border" key={idx}>
                <span className='pl-5'>(<b>{item.point_campaign_name}:</b></span>
                <span className="float-right pr-2"><b>{item.point.toLocaleString()}</b> ポイント)</span>
              </div>
            )}
        </div>
      </div>
      {appState.pointRegist ?
        <div className="row">
          <div className="col text-center">
            <button
              disabled={lockData}
              className="btn btn-primary w-75"
              onClick={() => setRegistClose()}>
              終了
            </button>
          </div>
        </div>
        :
        <div className="row">
          <div className="col text-center">
            <button
              disabled={lockData}
              className="btn btn-primary w-75 p-3"
              onClick={() => handleSubmitClick()}>
              確定
            </button>
          </div>
          <div className="col text-center">
            <button
              disabled={lockData}
              className="btn btn-enable w-75 p-3"
              onClick={() => handleCloseClick()}>
              戻る
            </button>
          </div>
        </div>
      }
    </div>
  );
};

export default PointDetail;